export default __webpack_public_path__ + "static/media/logos_mobile.c3891f26.svg";